import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';

import { router5Middleware } from 'redux-router5';
import { RouterProvider } from 'react-router5';

import './index.css';
import App from './App';
import {rootReducer} from './modules/reducers/root-reducer';
import {createRouter} from './modules/router/create-router'


const router = createRouter()

const routerMiddleware = router5Middleware(router);

const store = createStore(
    rootReducer,
    compose(
      applyMiddleware(routerMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : v => v
    )
)

document.title = "QA Engineer"

router.start(() => {
    ReactDOM.render(
        <RouterProvider router={router}>
            <Provider store={store}>
                <App />
            </Provider>
        </RouterProvider>
        , 
        document.getElementById('root')
    )
})
